import { render, staticRenderFns } from "./PLUnitDetail.vue?vue&type=template&id=62657edf"
import script from "./PLUnitDetail.vue?vue&type=script&lang=js"
export * from "./PLUnitDetail.vue?vue&type=script&lang=js"
import style0 from "./PLUnitDetail.vue?vue&type=style&index=0&id=62657edf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports